import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-area" }
const _hoisted_2 = { class: "main-header" }
const _hoisted_3 = { class: "header-bottom header-sticky" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-xl-2 col-lg-2" }
const _hoisted_7 = { class: "logo" }
const _hoisted_8 = { class: "col-xl-10 col-lg-10" }
const _hoisted_9 = { class: "menu-wrapper d-flex align-items-center justify-content-end" }
const _hoisted_10 = { class: "main-menu d-none d-lg-block" }
const _hoisted_11 = { id: "navigation" }
const _hoisted_12 = { class: "header-right-btn d-none d-lg-block ml-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"header-top d-none d-lg-block\" data-v-0a40365d><div class=\"container-fluid\" data-v-0a40365d><div class=\"col-xl-12\" data-v-0a40365d><div class=\"row d-flex justify-content-between align-items-center\" data-v-0a40365d><div class=\"header-info-left d-flex\" data-v-0a40365d><ul data-v-0a40365d><li data-v-0a40365d>Phone: +18594569774</li><li data-v-0a40365d>Email: globalholyministries@gmail.com</li></ul><div class=\"header-social\" data-v-0a40365d><ul data-v-0a40365d><li data-v-0a40365d><a href=\"#\" data-v-0a40365d><i class=\"fab fa-twitter\" data-v-0a40365d></i></a></li><li data-v-0a40365d><a href=\"#\" data-v-0a40365d><i class=\"fab fa-facebook-f\" data-v-0a40365d></i></a></li><li data-v-0a40365d><a href=\"#\" data-v-0a40365d><i class=\"fab fa-youtube\" data-v-0a40365d></i></a></li><li data-v-0a40365d><a href=\"#\" data-v-0a40365d><i class=\"fab fa-instagram\" data-v-0a40365d></i></a></li></ul></div></div><div class=\"header-info-right d-flex align-items-center\" data-v-0a40365d><div class=\"select-this\" data-v-0a40365d><form action=\"#\" data-v-0a40365d><div class=\"select-itms\" data-v-0a40365d><select name=\"select\" id=\"select1\" data-v-0a40365d><option value=\"\" data-v-0a40365d>English</option><option value=\"\" data-v-0a40365d>Spanish</option><option value=\"\" data-v-0a40365d>French</option><option value=\"\" data-v-0a40365d>Portuguese</option></select></div></form></div><ul class=\"contact-now\" data-v-0a40365d><li data-v-0a40365d><a href=\"#\" data-v-0a40365d>Subscribe Now</a></li></ul></div></div></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: "/assets/img/logo/logonew.png",
                        alt: "Global Holy Ministries"
                      }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("nav", null, [
                      _createElementVNode("ul", _hoisted_11, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/" }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("Home", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/about" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("About", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/events" }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("Events", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/contact" }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("Contact", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: "/contact",
                      class: "btn header-btn"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Donate", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-12" }, [
                _createElementVNode("div", { class: "mobile_menu d-block d-lg-none" })
              ], -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}